import { computed } from 'vue';
import type { RouteLocationNormalizedLoaded } from 'vue-router';
import type { HopDongFormConfig, HopDongFormMode } from '../types';

const CREATE_CONFIG: HopDongFormConfig = {
  mode: 'create',
  pageTitle: 'Tạo mới hợp đồng',
  documentTitleSuffix: 'Hợp đồng',
  breadcrumbActionLabel: 'Tạo mới',
  submitCreateMessage: 'Hợp đồng được tạo mới thành công',
  submitUpdateMessage: '',
  confirmCreateTitle: 'Bạn có chắc chắn hoàn tất tạo mới hợp đồng?',
  confirmUpdateTitle: '',
};

const EDIT_CONFIG: HopDongFormConfig = {
  mode: 'edit',
  pageTitle: 'Chỉnh sửa hợp đồng',
  documentTitleSuffix: 'Hợp đồng',
  breadcrumbActionLabel: 'Chỉnh sửa',
  submitCreateMessage: '',
  submitUpdateMessage: 'Hợp đồng được chỉnh sửa thành công',
  confirmCreateTitle: '',
  confirmUpdateTitle: 'Bạn có chắc chắn hoàn tất chỉnh sửa hợp đồng?',
};

export function resolveHopDongFormConfig(
  route: RouteLocationNormalizedLoaded
): HopDongFormConfig {
  const routeName = route.name?.toString() ?? '';

  if (
    routeName.includes('chinh-sua') ||
    routeName.includes('cap-nhat')
  ) {
    return EDIT_CONFIG;
  }

  return CREATE_CONFIG;
}

export function useHopDongFormMode(route: RouteLocationNormalizedLoaded) {
  const formConfig = computed(() => resolveHopDongFormConfig(route));

  const isCreating = computed(() => formConfig.value.mode === 'create');
  const isEditing = computed(() => formConfig.value.mode === 'edit');

  return {
    formConfig,
    isCreating,
    isEditing,
  };
}

export function isHopDongEditMode(mode: HopDongFormMode) {
  return mode === 'edit';
}
